import logo from '../images/logo.png'

export default function Header() {
    return (
        <div className="App-header">
            <img src={logo} className='Header-item logo' id="start" />
            <h2 className='Header-item' id='middle'>Micro-assessment Report Generator</h2>
            <img src={logo} className='Header-item logo' id="end" />
        </div>
    )
}